var _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "ico-close",
    width: 24,
    height: 24,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAACIUlEQVRIia3VS4hPYRgG8N9MU1iQO6NMlHuKYWlBETGElHIpycrGYlaS5LKwsrBQsjDJxoIFuUQKGzTuJRGrkdSMXLMRpU/vmU7Hd/4zNE+dxfney/Ndnvd9m7q6ujTAHHRgKWZhbLh+wmvcwRW8qEvRUrM+A/uxGSMy9glBmMgP4wKO4FXVsTkTvB33saMmeRXDsQ33sHMggk6cxbhBJK5iDE5jbx3BVhz7j8RVHC2fpCCYjhNDkLzAccwuExzC6IzjM3xskOgLnmbWR8aj/yGYGWrJJV+IFXifsfdiJdrxOGPfiLmJYD2GZRxasQBPQo5lkj6sQzfmhW8VqQQ2JYJlNcefiGuxw4LkAz5jbSSfHz45goTlLVEwdWiNSu0IktWxsyL5VUxtEN/WEvpthERyI0i6w689kk8eIHZUrpJzaKm0lep/LZrjThshqWUV7sajL8aDUFBOXWV8a46uWIfeklrSnV+Pr71GXVX0JILbNca+ilrSY0+KPnW5RLImNpLDrURwCT8yxndxFYVa2kq2KSWSVMlvM/G/UhtPBC+jn1eRqvhR2kWNFBPJTTzEoow9bfx5oaID+JpxSoHja44vJlx69KbK+vcYWP3N7g32NEj0r+gsxmi5Ds5g3xAkP4hTxU+10NKw2DWI2sjhG3ZH6+9HrpLT2FuCczXqquInzkfMyaqxrtzT/W0JiW6Ijjst9ZawJ0H0RA1djNnxN/AbvT1sij1OfWMAAAAASUVORK5CYII="
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoClose);
export default __webpack_public_path__ + "static/media/ico-close.b2b80e7f.svg";
export { ForwardRef as ReactComponent };